import LocalTime from "local-time";
import { Application } from "@hotwired/stimulus";
import HwComboboxController from "@josefarias/hotwire_combobox";

LocalTime.start();

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

application.register("hw-combobox", HwComboboxController);

export { application };
